var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "execution" },
    [
      _c(
        "basic-container",
        [
          _c("avue-crud", {
            ref: "crud",
            attrs: {
              page: _vm.page,
              data: _vm.tableData,
              permission: _vm.permissionList,
              "table-loading": _vm.tableLoading,
              option: _vm.tableOption,
              "before-open": _vm.handleOpenBefore,
            },
            on: {
              "update:page": function ($event) {
                _vm.page = $event
              },
              "on-load": _vm.getList,
              "search-change": _vm.searchChange,
              "refresh-change": _vm.refreshChange,
              "size-change": _vm.sizeChange,
              "current-change": _vm.currentChange,
              "row-update": _vm.handleUpdate,
              "row-save": _vm.handleSave,
              "row-del": _vm.handleDel,
            },
            scopedSlots: _vm._u([
              {
                key: "menuTreeForm",
                fn: function (ref) {
                  return [
                    _c("el-tree", {
                      ref: "menuTree",
                      staticClass: "filter-tree",
                      attrs: {
                        data: _vm.menuData,
                        "check-strictly": false,
                        props: _vm.defaultProps,
                        "default-checked-keys": _vm.checkedMenu,
                        "node-key": "id",
                        "highlight-current": "",
                        "show-checkbox": "",
                      },
                    }),
                  ]
                },
              },
            ]),
            model: {
              value: _vm.form,
              callback: function ($$v) {
                _vm.form = $$v
              },
              expression: "form",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }